const KEY = "trustedComputer";
const CHANGED = "trusted-computer-changed";

/** This preference belongs to this browser, not the user's cloud account. */
export function isTrustedComputer(): boolean {
  try {
    return localStorage.getItem(KEY) === "true";
  } catch {
    return false;
  }
}

export function saveTrustedComputer(trusted: boolean): void {
  localStorage.setItem(KEY, String(trusted));
  window.dispatchEvent(new Event(CHANGED));
}

export function subscribeTrustedComputer(onChange: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === KEY || event.key === null) {
      onChange();
    }
  };
  window.addEventListener(CHANGED, onChange);
  window.addEventListener("storage", onStorage);
  return () => {
    window.removeEventListener(CHANGED, onChange);
    window.removeEventListener("storage", onStorage);
  };
}
